import "./HeaderBar.css";
import React from "react";
import configData from "../AppConfig.json";
import { APP_BRAND } from "../AppConfig";
import { BaseURL } from "../../components/Common";

/**
 * Generates the header bar for the app.
 * @returns Header bar.
 */
export function HeaderBar() {
    return (
        <div className={`header header${APP_BRAND}`}>
            <div></div>
            <div>
                <a href={configData.Brand[APP_BRAND].url} target="_blank" rel="noreferrer">
                    <img
                        src={
                            window.brand === "Fielders"
                                ? BaseURL("images/centenary_logo.png")
                                : BaseURL("images/logo-lysaghtliving-white.png")
                        }
                        alt={configData.Brand[APP_BRAND].name}
                    ></img>
                </a>
            </div>
            <div>
                {configData.Brand[APP_BRAND].parent_url ? (
                    <a href={configData.Brand[APP_BRAND].parent_url} target="_blank" rel="noreferrer">
                        <img
                            src={configData.Brand[APP_BRAND].parent_logo}
                            alt={configData.Brand[APP_BRAND].parent_name}
                        ></img>
                    </a>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
}
